import {connect} from 'react-redux';
import TeamNew from './TeamNew';
import {
  requestEntityList,
  fetchEntityListNotDeleted,
  entitiesListIsDirty,
  setEntityDetailId,
  selectEntityUi,
  createNewDivision
} from '../../redux/actions/teams';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    teams: state.teams
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestEntityList: () => {
      dispatch(requestEntityList());
    },
    fetchEntityListNotDeleted: () => {
      dispatch(fetchEntityListNotDeleted());
    },
    entitiesListIsDirty: value => {
      dispatch(entitiesListIsDirty(value));
    },
    setEntityDetailId: id => {
      dispatch(setEntityDetailId(id));
    },
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    },
    createNewDivision: data => {
      dispatch(createNewDivision(data));
    }
  };
};

const TeamNewContainer = connect(mapStateToProps, mapDispatchToProps)(TeamNew);

export default TeamNewContainer;
